import { FC } from "react";
import DebtWebLayout from "./WebLayout";

const Debt: FC = () => {
  return (
    <div>
      <DebtWebLayout />
    </div>
  );
};

export default Debt;
